import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-hub',
})
export class SignetLogoHub {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://hub.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Hub.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'EpiHub Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-hub signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
